import { mapActions, mapGetters, mapMutations } from "vuex";
import { dynamicHead } from "../../mixins/dynamic-head";

export default {
    name: "sitemap",
    data() {
        return {};
    },
    mixins: [dynamicHead],
    components: {},
    computed: {
        ...mapGetters({
            categorises: "setting/menu",
            allPagesList: "setting/allPagesList",
            seoData: "setting/seoData",
        }),
    },
    created() {},
    mounted() {
        this.getSeoData("sitemap").then(() => {
            this.setPageItem(this.seoData);
        });
        if (!this.categorises) {
            this.getCategories();
        }
        this.getAllPages();
    },
    methods: {
        ...mapActions({
            getCategories: "setting/GET_CATEGORIES_MENU",
            getAllPages: "setting/GET_ALL_PAGES",
            getSeoData: "setting/GET_SEO_DATA",
        }),
        ...mapMutations({}),
    },
    destroyed() {},
};
